import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import BrandLogo from '../components/BrandLogo';
import { useAppSelector } from '../hooks/redux';
import { switchCountryAndRefresh } from '../content/siteContent';

const columns = {
  Platform: [
    { label: 'Credit Rating', href: '/credit-rating' },
    { label: 'Fundraising', href: '/fundraising' },
    { label: 'How it works', href: '/how-it-works' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'About', href: '/about' },
  ],
  Support: [
    { label: 'FAQ', href: '/faq' },
    { label: 'Contact Us', href: '/contact' },
    { label: 'Start rating & raise', href: '/#start' },
  ],
  Policy: [
    { label: 'Privacy Policy', href: '/privacy' },
    { label: 'Terms of Service', href: '/terms' },
    { label: 'Cookie Policy', href: '/cookies' },
  ],
};

export default function Footer() {
  const content = useAppSelector((s) => s.geo.content);

  return (
    <footer style={{ background: '#1A0A10', color: 'white', fontFamily: 'Inter, sans-serif' }}>
      <div className="container-wide" style={{ padding: '64px 0 48px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 48 }}>
          <div style={{ gridColumn: 'span 2', minWidth: 220 }}>
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 20, textDecoration: 'none' }}>
              <BrandLogo size={40} />
              <span style={{ fontSize: 26, fontWeight: 700, color: '#E91E63' }}>micus</span>
            </Link>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.60)', lineHeight: 1.8, maxWidth: 300, marginBottom: 28 }}>
              Credit rating is part of fundraising. Micus helps customers raise capital in a shorter span of time — starting with a clear rating.
            </p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <a href={`mailto:${content.email}`} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5, color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>
                <Mail size={14} /> {content.email}
              </a>
              <a href={content.phoneHref} style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5, color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>
                <Phone size={14} /> {content.phone}
              </a>
              <span style={{ display: 'flex', alignItems: 'center', gap: 10, fontSize: 13.5, color: 'rgba(255,255,255,0.45)' }}>
                <MapPin size={14} /> {content.address}
              </span>
            </div>
          </div>

          <div style={{ minWidth: 160 }}>
            <p style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#E91E63', marginBottom: 8 }}>Universal</p>
            <div style={{ width: 24, height: 2, background: 'linear-gradient(to right, #C2185B, #E91E63)', borderRadius: 2, marginBottom: 20 }} />
            <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
              <li>
                <button type="button" onClick={() => switchCountryAndRefresh('IN')} style={{ background: 'none', border: 'none', padding: 0, fontSize: 13.5, color: 'rgba(255,255,255,0.55)', cursor: 'pointer', fontFamily: 'inherit' }}>
                  India
                </button>
              </li>
              <li>
                <button type="button" onClick={() => switchCountryAndRefresh('US')} style={{ background: 'none', border: 'none', padding: 0, fontSize: 13.5, color: 'rgba(255,255,255,0.55)', cursor: 'pointer', fontFamily: 'inherit' }}>
                  United States
                </button>
              </li>
              <li>
                <Link to="/universal/not-listed" style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>
                  Not listed
                </Link>
              </li>
            </ul>
          </div>

          {Object.entries(columns).map(([title, links]) => (
            <div key={title} style={{ minWidth: 160 }}>
              <p style={{ fontSize: 11, fontWeight: 800, letterSpacing: '0.18em', textTransform: 'uppercase', color: '#E91E63', marginBottom: 8 }}>{title}</p>
              <div style={{ width: 24, height: 2, background: 'linear-gradient(to right, #C2185B, #E91E63)', borderRadius: 2, marginBottom: 20 }} />
              <ul style={{ listStyle: 'none', margin: 0, padding: 0, display: 'flex', flexDirection: 'column', gap: 10 }}>
                {links.map((link) => (
                  <li key={link.label}>
                    <Link to={link.href} style={{ fontSize: 13.5, color: 'rgba(255,255,255,0.55)', textDecoration: 'none' }}>
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
      <div className="container-wide">
        <div style={{ height: 1, background: 'rgba(255,255,255,0.08)' }} />
        <div style={{ padding: '24px 0', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: 16 }}>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', margin: 0 }}>© {new Date().getFullYear()} Micus. All rights reserved. · {content.countryLabel}</p>
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)', margin: 0 }}>micusify.com</p>
        </div>
      </div>
    </footer>
  );
}
